// Static UI data for the Home page. Game *listings* are no longer hardcoded —
// they are fetched live from the backend catalog (see src/api/catalog.ts).
// Only the platform category tiles (navigation, not inventory) live here.
import platformPlaystation from '../assets/home/platform-5.webp';
import platformSteam from '../assets/home/platform-3.webp';
import platformXbox from '../assets/home/platform-2.webp';
import platformEpic from '../assets/home/platform-4.webp';

export interface Platform {
  name: string;
  art: string;
}

export const platforms: Platform[] = [
  { name: 'PlayStation', art: platformPlaystation },
  { name: 'Steam', art: platformSteam },
  { name: 'Xbox', art: platformXbox },
  { name: 'EpicGames', art: platformEpic },
];
